<template lang="pug">
.costs-and-savings
  .content
    .text-container
      .title {{ $t('costsAndSavings.energyUpgrades.title') }}
      .selection
        Button(:label="$t('costsAndSavings.energyUpgrades.yes')" :value="true" :model="displayLoan" :class="{'p-button-outlined': !displayLoan}" @click="showLoan(true)")
        Button(:label="$t('costsAndSavings.energyUpgrades.no')" :value="false" :model="displayLoan" :class="{'p-button-outlined': displayLoan !== false }" @click="showLoan(false)")
      .form.loan-form(v-if="displayLoan")
        .input
          label(for="loan-amount") {{ $t('costsAndSavings.energyUpgrades.amount') }}
          .input-number
            .symbol {{ getCurrencySymbol(settings?.numberFormatOptions) }}
            InputText(
              v-model="loanAmount"
              :placeholder="$t('costsAndSavings.energyUpgrades.amountPlaceholder')"
              id="loan-amount"
              :min="minLoanAmount"
              :max="totalAmount"
              @input="thottledAmountChanged"
              type="number"
            )
        .input
          label(for="loan-type") {{ $t('costsAndSavings.energyUpgrades.type') }}
          Dropdown(
            v-model="selectedLoanValue"
            :options="loanOpts"
            optionLabel="name"
            optionValue="name"
            @change="updateSelectedLoan()"
          )
        .input
          label(for="loan-term") {{ $t('costsAndSavings.energyUpgrades.term') }}
          Dropdown(
            inputId="years"
            :options="loanTermOptions"
            v-model="term"
            optionLabel="label"
            optionValue="value"
            @change="applyRecommendations(false)"
            :disabled="selectedLoan.loanType === LoanType.Mortgage && displayMortgage"
          )

    .text-container
      .title {{ $t('costsAndSavings.mortgage.title') }}
      .selection
        Button(:label="$t('costsAndSavings.mortgage.yes')" :value="true" :model="displayMortgage" :class="{'p-button-outlined': !displayMortgage}" @click="showMortgage(true)")
        Button(
          :label="$t('costsAndSavings.mortgage.no')"
          :value="false" :model="displayMortgage"
          :class="{'p-button-outlined': displayMortgage !== false }"
          @click="showMortgage(false)"
          :disabled="selectedLoan.loanType === LoanType.Mortgage")
      .form.mortgage-form(v-if="displayMortgage")
        .input
          label(for="mortgage-amount") {{ $t('costsAndSavings.mortgage.amount') }}
          .input-number
            .symbol {{ getCurrencySymbol(settings?.numberFormatOptions) }}
            InputText(
              v-model="mortgageAmountValue"
              :placeholder="$t('costsAndSavings.mortgage.amountPlaceholder')"
              id="mortgage-amount"
              :min="1"
              @input="thottledAmountChanged"
              type="number"
            )
        .input
          label(for="years") {{ $t('costsAndSavings.mortgage.years') }}
          Dropdown(inputId="years" :options="yOptions" v-model="mortgageTerm" optionLabel="label" optionValue="value" @change="updateMortgageYears()")
    .cards-container-wrapper(v-if="selectedLoanOption && displayLoan && displayMortgage != undefined")
      Loading(
        :active="isLoadingReport"
        :is-full-page="false"
        loader="dots"
        color="#fff"
        background-color="#000"
        :z-index="1000"
      )
      .header(v-if="selectedLoanOption.loanType === LoanType.Mortgage")
        .title {{ $t('costsAndSavings.cardsTitle') }}
        .subtitle {{ $t('costsAndSavings.cardsSubtitle') }}
      .cards-container
        .ber-card
          .text {{ $t('costsAndSavings.currentBER') }}
          .rating
            RatingBox(:value="report && report.beforeRating ? report.beforeRating.code : ''")
        .arrow
          i.pi.pi-arrow-right
        .ber-card
          .text {{ $t('costsAndSavings.newBER') }}
          .rating
            RatingBox(:value="report && report.afterRating ? report.afterRating.code : ''")
      .cards-footer(v-if="selectedLoanOption.loanType === LoanType.Mortgage")
        .message.warning-message(v-if="report?.boiMortgage?.mortgageCostAfter?.apr === report?.boiMortgage?.mortgageCostBefore?.apr")
          .icon
            svg(height="50px" width="50px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 192.146 192.146" xml:space="preserve")
              path(d="M108.186,144.372c0,7.054-4.729,12.32-12.037,12.32h-0.254c-7.054,0-11.92-5.266-11.92-12.32 c0-7.298,5.012-12.31,12.174-12.31C103.311,132.062,108.059,137.054,108.186,144.372z M88.44,125.301h15.447l2.951-61.298H85.46 L88.44,125.301z M190.372,177.034c-2.237,3.664-6.214,5.921-10.493,5.921H12.282c-4.426,0-8.51-2.384-10.698-6.233 c-2.159-3.849-2.11-8.549,0.147-12.349l84.111-149.22c2.208-3.722,6.204-5.96,10.522-5.96h0.332 c4.445,0.107,8.441,2.618,10.513,6.546l83.515,149.229C192.717,168.768,192.629,173.331,190.372,177.034z M179.879,170.634 L96.354,21.454L12.292,170.634H179.879z")
          .text-wrapper
            .text {{ $t('costsAndSavings.warning.text') }}
            .subtext {{ $t('costsAndSavings.warning.subtext') }}
        .message.info-message(v-if="!allGroupsSelected && !report?.afterRating?.code.toLowerCase().includes('a') && report?.boiMortgage?.mortgageCostAfter?.apr !== report?.boiMortgage?.mortgageCostBefore?.apr")
          .icon
            svg( height="50px" width="50px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve")
              path(d="M256,0C114.84,0,0,114.84,0,256s114.84,256,256,256s256-114.84,256-256S397.16,0,256,0z M256,480C132.488,480,32,379.512,32,256S132.48,32,256,32c123.512,0,224,100.488,224,224S379.512,480,256,480z")
              path(d="M280.792,127.52c-5.8-5.896-12.888-8.848-21.288-8.848c-8.288,0-15.352,2.952-21.208,8.848 c-5.848,5.896-8.784,12.976-8.784,21.232c0,8.144,2.952,15.16,8.864,21.056c5.912,5.896,12.968,8.848,21.128,8.848 c8.272,0,15.344-2.912,21.2-8.76c5.856-5.832,8.784-12.88,8.784-21.144S286.592,133.416,280.792,127.52z")
              polygon(points="286.296,330.216 286.296,198 205.376,198 205.376,237.568 231.464,237.568 231.464,330.216 205.376,330.216 205.376,369.784 311.848,369.784 311.848,330.216")
          .text-wrapper
            .text {{ $t('costsAndSavings.info.text') }}
            .subtext {{ $t('costsAndSavings.info.subtext') }}

  aside
    .aside-content(v-if="displayLoan != undefined && displayMortgage != undefined")
      Card.project-cost
        template(#title) {{ $t('costsAndSavings.projectCost') }}
        template(#content)
          .results-table
            .content-row
              .label {{ $t('costsAndSavings.estimatedCost') }}
              .value {{ formatNumberToString(report?.totalMeasureCost) }}
            .content-row
              .label {{ $t('costsAndSavings.seaiGrants') }}
              .value.success -{{ formatNumberToString(report?.totalGrantCost) }}
            .content-row
              .label {{ $t('costsAndSavings.totalCost') }}
              .value {{ formatNumberToString(report?.totalMeasureCost - report?.totalGrantCost) }}
            .content-row.border-cost.totals
              .label {{ $t('costsAndSavings.repayments') }}
              .value
                .amount {{ formatNumberToString(report?.loanDetails?.estimatedMonthlyCost) }}
                .frequency {{ $t('costsAndSavings.frequency') }}
      Card.benefits
        template(#title)
          .benefits-label {{ $t('costsAndSavings.benefitsLabel') }}
          .benefits-title {{ $t('costsAndSavings.benefitsTitle') }}
          .benefits-subtitle {{ $t('costsAndSavings.benefitsSubtitle') }}
        template(#content)
          .results-table
            .content-row(v-if="report?.boiMortgage")
              .label {{ $t('costsAndSavings.energySavings') }}
                InfoTooltip(:message="$t('costsAndSavings.msg-content')" :direction="'top'")
              .value.success {{ formatNumberToString(report?.boiMortgage?.monthlyEnergySavingsInTerm) }}
            .content-row(v-if="report?.boiMortgage")
              .label {{ $t('costsAndSavings.mortgageSavingsMonthly') }}
              .value.success {{ formatNumberToString(report?.boiMortgage?.monthlyMortgageSavings) }}
            .content-row.border-cost.totals(v-if="report?.boiMortgage")
              .label {{ $t('costsAndSavings.totalSaving') }}
              .value.success
                .amount {{ formatNumberToString(report?.boiMortgage?.monthlySavingsInTerm) }}
                .frequency {{ $t('costsAndSavings.frequency') }}
      .savings-disclaimer {{ $t('costsAndSavings.savingsDisclaimer') }}
      ScheduleButton.schedule-button
Dialog(v-model:visible="showDialog" :header="' '" style="max-width: 450px;" :modal="true" :dismissableMask="true" class="msg-dialog")
  .msg(v-safe-html="$t('costsAndSavings.calculationMessage')")
  .btn-wrapper
    .close-btn(@click="() => showDialog = false") {{ $t('costsAndSavings.close') }}
.footer(v-if="selectedLoanOption && displayLoan" )
  .r-info {{ $t('costsAndSavings.regulatoryInfo.title') }}
  .section(v-if="selectedLoanOption.loanType === LoanType.Mortgage" )
    .s-title {{ $t('costsAndSavings.regulatoryInfo.mortgage.title') }}
    Panel.regulatory-panel(:header="$t('costsAndSavings.regulatoryInfo.mortgage.header')")
      div
        .text(v-safe-html="$t('costsAndSavings.regulatoryInfo.mortgage.info')")
    .flat-text {{ $t('costsAndSavings.regulatoryInfo.mortgage.cert') }}
    .warnings
      .warning-box {{ $t('costsAndSavings.legalWarnings.home') }}
      .warning-box {{ $t('costsAndSavings.legalWarnings.charges') }}
      .warning-box {{ $t('costsAndSavings.legalWarnings.arrears') }}
      .warning-box {{ $t('costsAndSavings.legalWarnings.offer') }}
    .flat-text {{ $t('costsAndSavings.regulatoryInfo.mortgage.regulation') }}

  .section(v-else-if="selectedLoanOption && selectedLoanOption.name.replace(/[\u200B-\u200D\uFEFF]/g, '').trim().toLowerCase() == 'home energy upgrade loan scheme'")
    .s-title {{ $t('costsAndSavings.regulatoryInfo.homeEnergyUpgrade.title') }}
    Panel.regulatory-panel(:header="$t('costsAndSavings.regulatoryInfo.homeEnergyUpgrade.header')")
      div
        .text(v-safe-html="$t('costsAndSavings.regulatoryInfo.homeEnergyUpgrade.info')")
    .warnings
      .warning-box {{ $t('costsAndSavings.legalWarnings.arrears') }}
      .warning-box {{ $t('costsAndSavings.legalWarnings.borrowingMoney') }}
    .flat-text {{ $t('costsAndSavings.regulatoryInfo.loan.regulation') }}
  .section(v-else)
    .s-title {{ $t('costsAndSavings.regulatoryInfo.loan.title') }}
    Panel.regulatory-panel(:header="$t('costsAndSavings.regulatoryInfo.loan.header')")
      div
        .text(v-safe-html="$t('costsAndSavings.regulatoryInfo.loan.info')")
    .warnings
      .warning-box {{ $t('costsAndSavings.legalWarnings.arrears') }}
      .warning-box {{ $t('costsAndSavings.legalWarnings.borrowingMoney') }}
    .flat-text {{ $t('costsAndSavings.regulatoryInfo.loan.regulation') }}
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import EstimatedCostsCard from "../aside/EstimatedCostsCard.vue";
import InputText from "primevue/inputtext";
import { storeToRefs } from "pinia";
import { useLoan, useRecommendations, useSettings } from "@/store";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import RatingBox from "../rating/RatingBox.vue";
import {
  formatNumberToString,
  formatPercentageToString,
  getCurrencySymbol,
  TrackingEvent,
} from "@/helpers";
import { DEFAULT_MAX_TERM } from "@/types/constants";
import Card from "primevue/card";
import ScheduleButton from "../ScheduleButton.vue";
import Loading from "vue-loading-overlay";
import { LoanType } from "@/types";
import { debounce } from "lodash-es";
import Dialog from "primevue/dialog";
import Panel from "primevue/panel";
import InfoTooltip from "@/components/commons/InfoTooltip.vue";

export default defineComponent({
  name: "CostsAndSavings",
  components: {
    EstimatedCostsCard,
    InputText,
    Dropdown,
    Button,
    RatingBox,
    Card,
    ScheduleButton,
    Loading,
    Dialog,
    Panel,
    InfoTooltip,
  },
  setup() {
    const loan = useLoan();
    const recommendations = useRecommendations();
    const { settings } = storeToRefs(useSettings());
    const {
      mortgageAmountValue,
      term,
      loanAmount,
      availableLoanOpts,
      selectedLoanOption,
      paymentBand,
      mortgageActive,
      mortgageTerm,
      displayLoan,
      displayMortgage,
    } = storeToRefs(loan);
    const { setSelectedLoanOption, loanAmountChanged } = loan;
    const { totalAmount } = storeToRefs(loan);
    const { report, isLoadingReport, allGroupsSelected } =
      storeToRefs(recommendations);
    const { applyRecommendations } = recommendations;
    loanAmount.value = report.value
      ? report.value.estimatedTotalCost
      : loanAmount.value;

    const noLoan = availableLoanOpts.value.find(
      (loan) => loan.name === "No loan"
    );
    const loanOpts = noLoan
      ? availableLoanOpts.value.filter((loan) => loan != noLoan)
      : availableLoanOpts.value.slice();

    const showDialog = ref(false);

    const thottledAmountChanged = debounce((e) => {
      const target = e?.originalEvent ? e.originalEvent.target : e.target;
      if (target && target.id && target.id === "mortgage-amount") {
        mortgageAmountValue.value = parseInt(mortgageAmountValue.value + "");
        validateMortgageAmount();
      } else if (target && target.id && target.id === "loan-amount") {
        loanAmount.value = parseInt(loanAmount.value + "");
        validateLoanAmount();
      }
      target.blur();
      loanAmountChanged();
    }, 1000);

    const yOptions = ref(
      Array.from(
        {
          length: settings.value?.defaultTerm
            ? settings.value.defaultTerm.max -
              settings.value.defaultTerm.min +
              1
            : DEFAULT_MAX_TERM,
        },
        (_, index) => {
          const y =
            index +
            (settings.value?.defaultTerm ? settings.value?.defaultTerm.min : 0);
          return {
            label: `${y} years`,
            value: y,
          };
        }
      )
    );

    const loanTermOptions = computed(() => {
      const { settings } = storeToRefs(useSettings());
      const [minTerm, maxTerm] = paymentBand.value
        ? [paymentBand.value.minTerm, paymentBand.value.maxTerm]
        : settings.value?.defaultTerm
        ? [settings.value.defaultTerm.min, settings.value.defaultTerm.max]
        : [1, DEFAULT_MAX_TERM];

      return Array.from({ length: maxTerm - minTerm + 1 }, (_, index) => ({
        label: `${index + minTerm} years`,
        value: index + minTerm,
      }));
    });

    const selectedLoanValue = ref(selectedLoanOption.value?.name);
    const selectedLoan = computed(() =>
      availableLoanOpts.value.find(
        (loan) => selectedLoanValue.value === loan.name
      )
    );

    const minLoanAmount = computed(() => {
      const mortgageMin = availableLoanOpts.value.find(
        (loan) => loan.loanType === LoanType.Mortgage
      )?.minAmount;
      return selectedLoanOption.value && selectedLoanOption.value.paymentBands
        ? selectedLoanOption.value.paymentBands.reduce(
            (minAmount, paymentBand) =>
              paymentBand.minAmount < minAmount
                ? paymentBand.minAmount
                : minAmount,
            Number.POSITIVE_INFINITY
          )
        : mortgageMin
        ? mortgageMin
        : 1;
    });

    function validateMortgageAmount() {
      if (
        mortgageAmountValue.value == undefined &&
        (report.value as any)?.boiMortgage
      ) {
        mortgageAmountValue.value = 0;
      }
    }

    function validateLoanAmount() {
      if (loanAmount.value > totalAmount.value)
        loanAmount.value = totalAmount.value;
      else if (loanAmount.value < minLoanAmount.value)
        loanAmount.value = minLoanAmount.value;
    }

    async function updateSelectedLoan() {
      if (selectedLoanValue.value === selectedLoanOption.value) return;
      if (selectedLoan.value) {
        await setSelectedLoanOption(selectedLoan.value);
        if (selectedLoan.value.loanType === LoanType.Mortgage) {
          showMortgage(true);
        }
        recommendations.emitRecommendationsReportResult(
          false,
          TrackingEvent.UserChangedLoan
        );
      }
    }

    function showMortgage(show: boolean) {
      if (show === displayMortgage.value) return;
      if (show) setMortgageDefaults();
      mortgageActive.value = show;
      displayMortgage.value = show;
      applyRecommendations();
    }

    function setMortgageDefaults() {
      const opt = loanOpts.find((loan) => loan.loanType === LoanType.Mortgage);
      mortgageAmountValue.value =
        opt && opt.defaultMortgageAmount ? opt.defaultMortgageAmount : 0;
      mortgageTerm.value = opt && opt.defaultTerm ? opt.defaultTerm : 1;
    }

    function showLoan(show: boolean) {
      if (show === displayLoan.value) return;
      displayLoan.value = show;
      if (!show && noLoan) {
        setSelectedLoanOption(noLoan);
      } else {
        // select default loan option or first option
        setSelectedLoanOption(
          settings.value && settings.value.defaultLoanOption
            ? loanOpts[settings.value.defaultLoanOption]
            : loanOpts[0]
        );
        selectedLoanValue.value = selectedLoanOption.value?.name;
      }
    }

    function updateMortgageYears() {
      if (selectedLoanOption.value?.loanType === LoanType.Mortgage) {
        term.value = mortgageTerm.value;
      }
      applyRecommendations();
    }

    const mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    return {
      mortgageAmountValue,
      validateMortgageAmount,
      loanAmount,
      term,
      yOptions,
      report,
      formatNumberToString,
      formatPercentageToString,
      applyRecommendations,
      selectedLoanValue,
      loanOpts,
      updateSelectedLoan,
      isLoadingReport,
      displayLoan,
      displayMortgage,
      loanTermOptions,
      totalAmount,
      thottledAmountChanged,
      showMortgage,
      showLoan,
      selectedLoan,
      LoanType,
      mortgageTerm,
      showDialog,
      updateMortgageYears,
      minLoanAmount,
      getCurrencySymbol,
      mobile,
      allGroupsSelected,
      selectedLoanOption,
    };
  },
});
</script>

<style lang="scss" scoped>
.costs-and-savings {
  display: flex;
  gap: 2rem;
  justify-content: space-between;

  aside {
    width: 26vw;
    max-width: 30rem;
  }

  .aside-content {
    width: 26vw;
    max-width: 30rem;
    display: flex;
    flex-direction: column;

    .loan-type {
      margin-bottom: 1.5rem;

      &:deep(.p-dropdown) {
        width: 100%;
      }
    }

    .border-cost {
      padding: 10px 5px;
      margin: 10px 0;
    }

    .content-row {
      padding: 5px;

      .value {
        font-weight: bold;
        font-size: 1.1rem;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .text-container {
      background-color: $background-color-default;
      padding: 1rem;

      .title {
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 0.75rem;
      }

      .selection {
        margin-bottom: 1rem;
      }

      .form {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;

        .input {
          display: flex;
          flex-direction: column;

          label {
            margin-bottom: 0.5rem;
          }
        }
      }

      .mortgage-submit {
        margin-top: 1rem;
      }
    }

    .cards-container-wrapper {
      .header {
        margin-bottom: 1rem;
      }
    }

    .cards-container {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 1.5rem;
      width: 100%;

      .card {
        width: 30%;
        background-color: $background-color-default;

        .title {
          display: flex;
          align-items: center;
          text-transform: uppercase;
          background-color: $background-color-disabled;
          height: 2rem;

          .text {
            padding-left: 1rem;
          }

          &:deep(.rating-box) {
            padding: 0;
            height: 2rem;

            .rating-value {
              align-items: center;
              display: flex;
            }
          }
        }

        .content {
          padding: 1rem;
          height: calc(100% - 2rem);

          .bold {
            font-weight: bold;
          }

          .amount {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-size: 1.75rem;
          }

          .message {
            color: $primary-color;
            font-weight: bold;
            font-size: 0.9rem;
            cursor: pointer;
          }
        }
      }

      .ber-card {
        display: flex;
        flex-grow: 1;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        text-align: center;
        background-color: $background-color-hover;

        &:deep(.rating-box) {
          height: 3.25rem;

          .rating-value {
            display: flex;
            align-items: center;
          }
        }
      }

      .arrow i {
        font-size: 1.2rem;
      }
    }
  }

  .content-row {
    display: flex;
    justify-content: space-between;
  }

  .success {
    color: $success-color;
  }

  .schedule-button {
    height: calc(3rem + 10px);
  }

  .totals .value {
    display: flex;
  }

  .cards-footer {
    margin-top: 2rem;

    .message {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border: 2px solid $primary-color-hover;
      border-radius: 3px;
      background-color: $background-color-default;
      padding: 1rem 1.75rem;

      &.warning-message {
        border-color: $error-color;

        svg {
          fill: $error-color !important;
        }
      }

      .icon {
        margin-right: 1.5rem;

        svg {
          fill: $primary-color-hover;
        }
      }

      .text-wrapper {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 1.5rem;
        border-left: 2px solid $border-color;

        .text {
          font-size: 1.1rem;
          font-weight: bold;
        }

        .subtext {
          font-size: 0.9rem;
        }
      }
    }
  }
}

@media screen and (max-width: 1120px) {
  .costs-and-savings {
    flex-direction: column;

    aside {
      width: auto;
      max-width: none;
    }

    .aside-content {
      flex-direction: row;
      width: 100%;
      max-width: none;
      gap: 1rem;

      .p-card {
        width: 50%;
      }
    }

    .schedule-button {
      display: none;
    }
  }
}

@media screen and (max-width: 720px) {
  .costs-and-savings {
    flex-direction: column;

    .cards-container {
      //flex-direction: column;

      .card {
        width: 100% !important;
      }
    }

    .aside-content {
      flex-direction: column;

      .p-card {
        width: 100%;
      }
    }
  }
}

.input-number {
  .symbol {
    position: absolute;
    padding: 0.5rem 0.75rem;
    border-right: 1px solid $border-color;
  }

  input {
    padding-left: 3rem;
  }
}

.footer {
  margin-top: 5rem;
  cursor: default;

  .r-info {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }

  .section {
    margin-bottom: 3rem;

    .s-title {
      font-size: 1.1rem;
      font-weight: 700;
      margin-bottom: 1rem;
    }

    .regulatory-panel {
      &:deep(.p-panel-header) {
        font-weight: 500;
        border: 1px solid var(--berwow-border-color);
      }
      &:deep(.p-panel-header), &:deep(.p-panel-content) {
        cursor: default;
        padding: 1.5rem 1rem;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        background: var(--berwow-background-color-default);
      }
    }

    .flat-text {
      padding: 0.1rem;
      margin-top: 1rem;
    }

    .warnings {
      .warning-box {
        margin: 1rem 0;
        padding: 1rem;
        background-color: $background-color-default;
        border: 2px solid $font-color-secondary;
        font-weight: bold;
      }
    }
  }
}

.label span.icon {
  margin-left: 0.25rem;

  svg {
    cursor: pointer !important;
  }
}

.msg-dialog {
  &:deep(.msgTitle) {
    font-size: 1.1rem;
    font-weight: bold;
  }

  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close-btn {
    display: block;
    width: min-content;
    border: 2px solid;
    padding: 1rem 3rem;
    margin-top: 1rem;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
